"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useRef } from "react";

export default function EnsureUserRecordClient() {
  const { user, isLoaded } = useUser();
  const ensuredRef = useRef(false);

  useEffect(() => {
    if (!isLoaded || !user || ensuredRef.current) return;
    ensuredRef.current = true;

    const controller = new AbortController();
    const ensure = async () => {
      try {
        await fetch("/api/user/ensure", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          signal: controller.signal,
        });
      } catch {
        ensuredRef.current = false;
      }
    };
    ensure();

    return () => controller.abort();
  }, [isLoaded, user]);

  return null;
}

